@use "~theme/breakpoints";
@use "~theme/typography";

@mixin border {
  border-radius: 8px;
  box-shadow: 0 4px 4px 0 rgb(0 0 0 / 10%);
}

@mixin card {
  @include border;
  background-color: var(--white);
  max-width: var(--max-desktop-width);
  flex-grow: 1;
  margin: 18px var(--card-gutter-width);
}

.card {
  @include card;
}

.content {
  padding: 24px;

  @include breakpoints.desktop {
    padding-left: 32px;
    padding-right: 32px;
  }
}

.contentNew {
  padding: 24px;
  background: white;

  @include breakpoints.desktop {
    padding-left: 32px;
    padding-right: 32px;
  }
}

.twoColumn,
.readOnlyTwoColumn {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.readOnlyTwoColumn {
  margin-bottom: 8px;
  max-width: 308px;

  @include breakpoints.desktop {
    margin-bottom: 0;
  }
}

.desktopTwoColumn {
  @include breakpoints.desktop {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
}

.emptyError {
  display: none;
}

.alwaysVisible {
  display: inherit;
}

.hr {
  border: none;
  background-color: var(--blue-01-at-30);
  height: 1px;
  margin: 36px 0;

  @include breakpoints.desktop {
    margin-top: 0;
  }
}

.buttonGroup {
  margin-bottom: 16px;

  @include breakpoints.desktop {
    margin-top: 12px;
  }
}

.radioButton {
  margin-bottom: 16px;
}

.ssnField {
  max-width: 200px;
}

.ssnContainer {
  margin-right: 16px;
}

.fieldWithTooltip {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}

.guideList {
  margin: 0 0 0 20px;
  padding: 0;
}

.tooltipContainer {
  @include typography.caption;
  max-width: none;
  color: var(--blue-02);
  margin-top: 0;
  margin-bottom: 58px;
  display: flex;
  align-items: center;
  gap: 4px;
  line-height: 140%;
  @include breakpoints.desktop {
    margin-bottom: 38px;
  }

  > * {
    display: block;
    margin-left: 0;
  }

  button:last-child {
    top: 0;
    margin-left: -10px;
  }

  .tooltip {
    margin-bottom: 0;
  }

  .tooltip::after {
    border-width: 10px;
  }

  .tooltipCloseIcon {
    margin-top: 0;
    margin-right: 0;
  }
}

.tooltipAlignedToInput {
  @include breakpoints.desktop {
    margin-bottom: 0;
    align-self: flex-end;
    transform: translateY(-36px);
  }
}

.tooltipLabel {
  display: inline-block;
  width: 92px;
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
}

.fieldGroup:last-child {
  margin-bottom: 16px;
}

.FieldGroup {
  margin: 0px;
}

.FieldLegend {
  position: initial;
  width: 100%;
  text-align: initial;
}

.versionBG{
  background: var(--gray-05);
  border-radius: 20px;
}
